import { isChildDescendant } from '../global-utils';

export const shouldHideTheMenu = ({ displayMenu, child, stem }) =>
  displayMenu &&
  !isChildDescendant({
    child,
    parentId: stem,
  });
